import { FC } from 'react';
import {
  Button,
  BreadcrumbItem as ChakraBreadcrumbItem,
  BreadcrumbItemProps as ChakraBreadcrumbItemProps,
  Text,
} from '@chakra-ui/react';

type BreadcumbItemProps = ChakraBreadcrumbItemProps & {
  isActive: boolean;
  onClick: () => void;
  value: string;
};

export const BreadcrumbItem: FC<BreadcumbItemProps> = ({
  isActive,
  onClick,
  value,
  // Need to pass props through to ensure separators work
  ...props
}) => {
  if (isActive) {
    // Non-clickable breadcrumb
    return (
      <ChakraBreadcrumbItem data-testid="directory-breadcrumb-item" {...props}>
        <Text noOfLines={1} color="gray.700" fontSize="lg" fontWeight="bold">
          {value}
        </Text>
      </ChakraBreadcrumbItem>
    );
  }

  return (
    // Clickable breadcrumb
    <ChakraBreadcrumbItem data-testid="directory-breadcrumb-item" {...props}>
      <Button
        onClick={onClick}
        color={isActive ? 'gray.700' : 'gray.500'}
        fontWeight={isActive ? 'bold' : 'medium'}
        maxWidth={500} // needed for truncating
        variant="link"
      >
        <Text
          noOfLines={1}
          display="inline" // needed for truncating (should be after `noOfLines`)
        >
          {value}
        </Text>
      </Button>
    </ChakraBreadcrumbItem>
  );
};
